import { Link } from 'react-router-dom';
import '../styles/samantha.css';
import DemoForm from './DemoForm';
import { company } from '../content/company';
import '../styles/quiet-invitation.css';

export default function Hero() {
  return <section id="home" className="qi-hero" aria-label="AI and workflow automation">
    <img className="qi-plate-bg" src={`${import.meta.env.BASE_URL}plates/automatehq-sunny-hero.png`} alt="" aria-hidden="true" />
    <div className="qi-shell">
      <div className="qi-split">
        <div className="qi-copy">
          <h1 className="qi-headline">AI, automation and apps that take work off your <span>plate.</span></h1>
          <p className="qi-subhead">{company.description} We connect your tools, automate repetitive tasks and build small apps for work spreadsheets cannot handle. From enquiry follow-ups to document processing, we turn manual steps into working systems.</p>
          <a className="studio-text-link" href="#services">Explore what we can help with <span aria-hidden="true">↘</span></a>
          <Link to="/chat/" className="sam-entry"><img src="/images/samantha.jpg" alt="" width="42" height="42" /><span><strong>Talk through a problem ↗</strong><small>Get a practical first suggestion from our AI assistant.</small></span></Link>
          <div className="qi-hero-note"><span className="qi-note-mark" aria-hidden="true">↳</span><p>We start by learning how your team works, then build around the task that needs fixing.</p></div>
        </div>
        <div className="qi-form-card" id="request-demo">
          <div className="qi-form-title"><span className="qi-form-intro">A good place to start</span><h2>Let's talk about<br className="form-title-break" /> your workflow.</h2><p>Send a short enquiry. I'll follow up personally to understand what you need and arrange a relevant demo.</p></div>
          <DemoForm />
        </div>
      </div>
    </div>
  </section>;
}
